import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Select, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  createAutomode,
  isLoadingCreateAutomodeSelector,
  isLoadingUpdateAutomodeSelector,
  updateAutomode
} from 'src/store/automode';

const { TextArea } = Input;

const INTERVAL_OPTIONS = Array.from({ length: 15 }, (_, index) => index + 1);

export const AutomodeModal = ({ form, selectedAutomode, isModalOpen, onCancel }) => {
  const { t } = useTranslation('automode');
  const dispatch = useDispatch();

  const isLoadingCreate = useSelector(isLoadingCreateAutomodeSelector);
  const isLoadingUpdate = useSelector(isLoadingUpdateAutomodeSelector);

  const isEdit = Boolean(selectedAutomode?._id);
  const isLoading = isLoadingCreate || isLoadingUpdate;

  const intervalOptions = useMemo(
    () => INTERVAL_OPTIONS.map((value) => ({ value, label: t(`intervals.${value}`) })),
    [t]
  );

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (isEdit) {
        dispatch(
          updateAutomode({
            id: selectedAutomode._id,
            payload: values,
            onCancel
          })
        );
        return;
      }

      dispatch(
        createAutomode({
          payload: values,
          onCancel
        })
      );
    } catch (error) {
      console.error('AutomodeModal[validate]', error);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      title={isEdit ? t('modal.edit_title') : t('modal.create_title')}
      okText={isEdit ? t('actions.save') : t('actions.create')}
      cancelText={t('actions.cancel')}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={isLoading}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('fields.message')}
          name="message"
          rules={[{ required: true, message: t('errors.message_required') }]}
        >
          <TextArea rows={5} placeholder={t('fields.message_placeholder')} maxLength={500} />
        </Form.Item>

        <Form.Item
          label={t('fields.interval')}
          name="intervalMinutes"
          rules={[{ required: true, message: t('errors.interval_required') }]}
        >
          <Select options={intervalOptions} />
        </Form.Item>

        <Form.Item
          label={t('fields.active')}
          name="active"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};
